import { render, staticRenderFns } from "./19-member-profile-extras.vue?vue&type=template&id=13bea39a&scoped=true"
import script from "./19-member-profile-extras.vue?vue&type=script&lang=js"
export * from "./19-member-profile-extras.vue?vue&type=script&lang=js"
import style0 from "./19-member-profile-extras.vue?vue&type=style&index=0&id=13bea39a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bea39a",
  null
  
)

export default component.exports